/**
 * Aviso do painel de quem distribui: os escritórios com processo esperando distribuição, cada
 * um levando direto à aba Distribuir (docs/PLANO_REGRAS_DISTRIBUICAO.md, Bloco 2).
 */
import { useQuery } from '@tanstack/react-query';
import { ArrowRight, GitFork } from 'lucide-react';
import { Link } from 'react-router-dom';

import { fetchDistribuicaoPendente } from '@/api/regrasDistribuicao';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { queryKeys } from '@/lib/pwa/queryConfig';

export function DistribuicaoPendenteCard() {
  const { data } = useQuery({
    queryKey: queryKeys.escritorios.distribuicaoPendente,
    queryFn: fetchDistribuicaoPendente,
    staleTime: 60_000,
  });
  if (!data?.length) return null;

  return (
    <Card>
      <CardContent className="p-4">
        <div className="mb-3 flex items-center gap-2">
          <GitFork className="h-4 w-4 text-primary" aria-hidden="true" />
          <h3 className="text-sm font-semibold">Processos para distribuir</h3>
        </div>
        <ul className="divide-y">
          {data.map((p) => (
            <li key={p.escritorio_id} className="flex flex-wrap items-center justify-between gap-2 py-2.5">
              <p className="min-w-0 break-words text-sm">
                <span className="font-medium tabular-nums text-primary">{p.total}</span>{' '}
                {p.total === 1 ? 'processo chegou' : 'processos chegaram'} em{' '}
                <span className="font-medium">{p.nome}</span>
              </p>
              <Button asChild variant="outline" className="h-11 sm:h-9">
                <Link to={`/app/escritorios/${p.escritorio_id}?aba=distribuir`}>
                  Distribuir
                  <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
                </Link>
              </Button>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
